import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from 'src/app/models';
import { ApiService } from '../../api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiMarkingProductListService {

  constructor(
    private api: ApiService
  ) { }

   /**
   * 
   * @returns 
   */
    createIncludingAll(): Observable<Res> {

      return this.api.get('createPriceListFromPublishedProducts', '', 'private', 'integrationMarking');
    }
  
  
    /**
     * 
     * @param params any
     * @returns Observable<Res>
     */
    getList(params: any): Observable<Res> {
  
      return this.api.post('marking/productList', params, 'private', 'integrationMarking');
    }
  
  
    /**
     * 
     * @param id 
     * @returns 
     */
    getInfo(id: string): Observable<Res> {
  
      return this.api.get('marking/getImportProductById', id, 'private', 'integrationMarking');
    }


    /**
     * 
     * @param methodName 
     * @param params 
     * @returns 
     */
    sendTo(methodName:string, params:any): Observable<Res> {

      return this.api.post('marking/' + [methodName], params, 'private', 'integrationMarking');
    }


    /**
     * 
     * @param methodName 
     * @param params 
     * @returns 
     */
     getProductsXmls(methodName:string, params:any): Observable<Res> {

      return this.api.post('marking/' + [methodName], params, 'private', 'integrationMarking');
    }
  
  
    /**
     * 
     * @param params any
     * @returns Observable<Res>
     */
    save(params: any): Observable<Res> {
  
      return this.api.post('marking/importProducts', params, 'private', 'integrationMarking');
    }
  
  
    /**
     * 
     */
    delete(params: any): Observable<Res> {
  
      return this.api.post('marking/deleteImportProducts', params, 'private', 'integrationMarking');
    }
}
